import GroupedContent from '@pixelunion/grouped-content';
import reframe from 'reframe.js';

export default class RTE {
  constructor(component) {
    this.el = component.el;
    this.$el = $(this.el);
    this.setupTabs();
    reframe(this.$el.find('iframe').addBack('iframe'));

    const videos = this.el.querySelectorAll('iframe');
    for (let i = 0; i < videos.length; i++) {
      const video = videos[i];
      if (video.classList.contains('highlight')) {
        video.parentNode.classList.add('highlight');
      }
    }
  }

  setupTabs() {
    return new GroupedContent(this.$el.get(0), { layout: 'tabs', intelliparse: false });
  }
}
